/**
 * @generated SignedSource<<11250406a15658357fb92ac85f3d6a1a>>
 * @relayHash ca426fbcc1553e6f374a9b2abed73085
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ce1d8f648b14dae092378a9954ead2d523b0d2f220c793c8da5ff5228523b1f4

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type overview_agentIdentityQuery$variables = {
  helpCenterAri: string;
};
export type overview_agentIdentityQuery$data = {
  readonly csmAi_getAiHubByHelpCenterAri: {
    readonly agent?: {
      readonly " $fragmentSpreads": FragmentRefs<"relayAgentIdentity_AtlassianCsmAgentIdentity">;
    } | null | undefined;
  } | null | undefined;
};
export type overview_agentIdentityQuery = {
  response: overview_agentIdentityQuery$data;
  variables: overview_agentIdentityQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "overview_agentIdentityQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "relayAgentIdentity_AtlassianCsmAgentIdentity"
                  }
                ]
              }
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "overview_agentIdentityQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "purpose"
                      },
                      {
                        "concreteType": "CsmAiAgentTone",
                        "kind": "LinkedField",
                        "name": "tone",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "type"
                          }
                        ]
                      }
                    ],
                    "type": "CsmAiAgent"
                  }
                ]
              },
              (v3/*: any*/)
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "ce1d8f648b14dae092378a9954ead2d523b0d2f220c793c8da5ff5228523b1f4",
    "metadata": {},
    "name": "overview_agentIdentityQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e9257ebd8599867631956c6c81de3a90";

export default node;
